var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol0, _symbol1, _symbol10, _symbol11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsEmotionIconsSpriteV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-calm",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#C9E3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0 66.0 Q46.0 60.0 60.0 66.0 Q74.0 72.0 88.0 66.0",
    stroke: "#1E374B",
    strokeWidth: 5.5,
    fill: "none",
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 42,
    rx: 13,
    ry: 3.2,
    stroke: "#1E374B",
    strokeWidth: 2.5,
    fill: "none",
    opacity: 0.4
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-content",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#8FBBA0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 15,
    fill: "#1E374B"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-satisfied",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#3F8862"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 14,
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 72,
    x2: 77,
    y2: 77,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 72,
    x2: 43,
    y2: 77,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 48,
    x2: 43,
    y2: 43,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 48,
    x2: 77,
    y2: 43,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-very_satisfied",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#245A3D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 15,
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.7,
    y1: 72.7,
    x2: 80.5,
    y2: 80.5,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 78,
    x2: 60,
    y2: 89,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.3,
    y1: 72.7,
    x2: 39.5,
    y2: 80.5,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 60,
    x2: 31,
    y2: 60,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.3,
    y1: 47.3,
    x2: 39.5,
    y2: 39.5,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 42,
    x2: 60,
    y2: 31,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.7,
    y1: 47.3,
    x2: 80.5,
    y2: 39.5,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 60,
    x2: 89,
    y2: 60,
    stroke: "#FFFAF5",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    opacity: 1
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-excited",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#143223"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 11,
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74,
    y1: 60,
    x2: 90,
    y2: 60,
    stroke: "#FFFAF5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.1,
    y1: 67,
    x2: 80.8,
    y2: 72,
    stroke: "#FFFAF5",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 72.1,
    x2: 76,
    y2: 87.7,
    stroke: "#FFFAF5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 74,
    x2: 60,
    y2: 84,
    stroke: "#FFFAF5",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 72.1,
    x2: 45,
    y2: 86,
    stroke: "#FFFAF5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.9,
    y1: 67,
    x2: 39.2,
    y2: 72,
    stroke: "#FFFAF5",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 60,
    x2: 28,
    y2: 60,
    stroke: "#FFFAF5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.9,
    y1: 53,
    x2: 39.2,
    y2: 48,
    stroke: "#FFFAF5",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 47.9,
    x2: 45,
    y2: 34,
    stroke: "#FFFAF5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 46,
    x2: 60,
    y2: 36,
    stroke: "#FFFAF5",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 47.9,
    x2: 76,
    y2: 32.3,
    stroke: "#FFFAF5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.1,
    y1: 53,
    x2: 80.8,
    y2: 48,
    stroke: "#FFFAF5",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-neutral",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#9B9B96"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 60,
    x2: 80,
    y2: 60,
    stroke: "#FFFAF5",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-worried",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#B98EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0 54.0 Q33.0 47.0 42.0 54.0 Q51.0 61.0 60.0 54.0 Q69.0 47.0 78.0 54.0 Q87.0 61.0 96.0 54.0",
    stroke: "#1E374B",
    strokeWidth: 5.5,
    fill: "none",
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0 76.0 Q39.0 71.0 46.0 76.0 Q53.0 81.0 60.0 76.0 Q67.0 71.0 74.0 76.0 Q81.0 81.0 88.0 76.0",
    stroke: "#1E374B",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.55
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-sad",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#8E5A9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 30 C72 46 80 60 80 72 C80 87 71 96 60 96 C49 96 40 87 40 72 C40 60 48 46 60 30 Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 102,
    rx: 15,
    ry: 3.2,
    stroke: "#FFFAF5",
    strokeWidth: 2.5,
    fill: "none",
    opacity: 0.4
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-dissatisfied",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#6F397F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0 56.0 Q44.5 49.0 60.0 56.0 Q75.5 63.0 91.0 56.0",
    stroke: "#FFFAF5",
    strokeWidth: 6.5,
    fill: "none",
    strokeLinecap: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0 78.0 Q50.0 74.0 60.0 78.0 Q70.0 82.0 80.0 78.0",
    stroke: "#FFFAF5",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.45
  }))), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-frustrated",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#5A2C69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0 26.0 C76.0 46.0 80.0 62.0 73.0 74.0 C78.0 68.0 82.0 56.0 75.0 42.0 C90.0 60.0 86.0 90.0 60.0 98.0 C38.0 94.0 36.0 72.0 46.0 62.0 C44.0 72.0 52.0 74.0 54.0 66.0 C48.0 54.0 54.0 38.0 60.0 26.0 Z",
    fill: "#FFFAF5"
  }))), _symbol1 || (_symbol1 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-stressed",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#50265E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0 29.0 C74.7 47.4 78.4 62.2 72.0 73.2 C76.6 67.7 80.2 56.6 73.8 43.8 C87.6 60.3 83.9 87.9 60.0 95.3 C39.8 91.6 37.9 71.4 47.1 62.2 C45.3 71.4 52.6 73.2 54.5 65.8 C49.0 54.8 54.5 40.1 66.0 29.0 Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0 62.8 C90.4 70.8 92.0 77.2 89.2 82.0 C91.2 79.6 92.8 74.8 90.0 69.2 C96.0 76.4 94.4 88.4 84.0 91.6 C75.2 90.0 74.4 81.2 78.4 77.2 C77.6 81.2 80.8 82.0 81.6 78.8 C79.2 74.0 81.6 67.6 87.0 62.8 Z",
    fill: "#FFFAF5",
    opacity: 0.75
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-very_dissatisfied",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#472154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0 21.4 C77.9 43.8 82.4 61.8 74.6 75.2 C80.2 68.5 84.6 55.0 76.8 39.4 C93.6 59.5 89.1 93.1 60.0 102.1 C35.4 97.6 33.1 73.0 44.3 61.8 C42.1 73.0 51.0 75.2 53.3 66.2 C46.6 52.8 53.3 34.9 60.0 21.4 Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0 63.0 C40.0 73.0 42.0 81.0 38.5 87.0 C41.0 84.0 43.0 78.0 39.5 71.0 C47.0 80.0 45.0 95.0 32.0 99.0 C21.0 97.0 20.0 86.0 25.0 81.0 C24.0 86.0 28.0 87.0 29.0 83.0 C26.0 77.0 29.0 69.0 30.0 63.0 Z",
    fill: "#FFFAF5",
    opacity: 0.8
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "emo-extremely_dissatisfied",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    fill: "#2D1432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0 20.3 C78.4 43.3 83.0 61.7 75.0 75.5 C80.7 68.6 85.3 54.8 77.2 38.7 C94.5 59.4 89.9 93.9 60.0 103.1 C34.7 98.5 32.4 73.2 43.9 61.7 C41.6 73.2 50.8 75.5 53.1 66.3 C46.2 52.5 53.1 34.1 60.0 20.3 Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 22 L66 10 L72 20",
    stroke: "#FFFAF5",
    strokeWidth: 3.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 46 L104 40 L100 52",
    stroke: "#FFFAF5",
    strokeWidth: 3.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 46 L16 42 L22 54",
    stroke: "#FFFAF5",
    strokeWidth: 3.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsEmotionIconsSpriteV2);
export default __webpack_public_path__ + "static/media/AS_Emotion_Icons_Sprite_v2.d260357a0cb3ea590236f17a4abe8190.svg";
export { ForwardRef as ReactComponent };